import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Play,
  Plus,
  Download,
  Share2,
  ChevronRight,
  Star,
  Calendar,
  Globe,
} from "lucide-react";

// Mock similar films data
const SIMILAR_FILMS = [
  {
    id: 2,
    title: "Touki Bouki",
    originalYear: 1973,
    country: "Senegal",
    restoredQuality: "4K",
    image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=600&h=900&fit=crop",
  },
  {
    id: 3,
    title: "Black Girl",
    originalYear: 1966,
    country: "Senegal",
    restoredQuality: "2K",
    image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=600&h=900&fit=crop",
  },
  {
    id: 4,
    title: "Yeelen",
    originalYear: 1987,
    country: "Mali",
    restoredQuality: "4K",
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=600&h=900&fit=crop",
  },
  {
    id: 5,
    title: "Mandabi",
    originalYear: 1968,
    country: "Senegal",
    restoredQuality: "2K",
    image: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=600&h=900&fit=crop",
  },
];

const DetailPage = () => {
  useEffect(() => {
  try {
    const adEl = document.querySelector(".adsbygoogle");
    // Only push if the slot hasn't been filled yet
    if (adEl && !adEl.getAttribute("data-adsbygoogle-status")) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  } catch (e) {
    console.error("AdSense error:", e);
  }
}, []);
  
  const location = useLocation();
  const navigate = useNavigate();
  const content = location.state?.content;

  const handleBack = () => {
    navigate(-1);
  };

  const handlePlay = () => {
    navigate("/player", { state: { content } });
  };

  const handleSimilarClick = (film) => {
    navigate("/detail", { state: { content: film } });
  };

  if (!content) {
    return (
      <div className="detail-container">
        <div style={{ padding: "40px 20px", textAlign: "center" }}>
          <h2 style={{ marginBottom: "16px" }}>Content not found</h2>
          <button className="btn-primary" onClick={() => navigate("/")}>
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-container fade-in-up">
      <div className="detail-hero">
        <img
          src={content.image}
          alt={content.title}
          className="detail-hero-image"
        />
        <div className="detail-gradient" />
        <button className="detail-back-btn" onClick={handleBack}>
          <ChevronRight
            size={24}
            style={{ transform: "rotate(180deg)" }}
          />
        </button>
      </div>

      <div className="detail-content">
        <span className="heritage-badge">
          {content.restoredQuality} AI-Restored
        </span>
        <h1 className="detail-title">{content.title}</h1>

        <div className="detail-meta">
          <span className="rating">
            <Star size={16} fill="currentColor" />
            {content.rating}
          </span>
          <span className="meta-item">
            <Calendar size={15} />
            {content.originalYear}
          </span>
          <span className="meta-item">
            <Globe size={15} />
            {content.country}
          </span>
          <span>{content.duration}</span>
        </div>

        <div className="detail-actions">
          <button className="btn-primary" style={{ flex: 1 }} onClick={handlePlay}>
            <Play size={20} fill="currentColor" />
            Watch Film
          </button>
          <button className="btn-secondary">
            <Plus size={24} />
          </button>
          <button className="btn-secondary">
            <Download size={20} />
          </button>
          <button className="btn-secondary">
            <Share2 size={20} />
          </button>
        </div>

        <p className="detail-description">{content.description}</p>

        <div className="detail-section">
          <h3 className="detail-section-title">Film Details</h3>
          <div className="info-grid">
            <div className="info-item">
              <div className="info-label">Director</div>
              <div className="info-value">{content.director}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Language</div>
              <div className="info-value">{content.language}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Genre</div>
              <div className="info-value">{content.genre}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Restoration</div>
              <div className="info-value">{content.restoredQuality} Quality</div>
            </div>
          </div>
        </div>

        <div className="detail-section">
          <h3 className="detail-section-title">Cultural Significance</h3>
          <p className="detail-description">{content.significance}</p>
        </div>

        <div className="detail-section">
          <h3 className="detail-section-title">Similar Films</h3>
          <div className="content-grid">
            {SIMILAR_FILMS.map((film) => (
              <div
                key={film.id}
                className="content-card"
                onClick={() => handleSimilarClick(film)}
              >
                <img
                  src={film.image}
                  alt={film.title}
                  className="content-card-image"
                />
                <span className="quality-badge">{film.restoredQuality}</span>
                <div className="content-card-info">
                  <div className="content-card-title">{film.title}</div>
                  <div className="content-card-meta">
                    {film.originalYear} • {film.country}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* ✅ Ad banner inside the single return, at the bottom */}
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXX"
        data-ad-slot="XXXXXXXX"
        data-ad-format="auto">
      </ins>
    </div>
  );
};

export default DetailPage;